import React from 'react';
import { gql } from '@apollo/client';
import { AdminEntityMergeRequestItemProps } from '../../AdminEntityMergeRequestItem';
import { useLocalization } from '../../../../../../../../util/useLocalization';
import AdminMergeItemBasicConflictField from '../../components/basicConflictField/AdminMergeItemBasicConflictField';
import { Locale } from '../../../../../../../../../localization/LocalizationKeys';
import {
  MergeItemAffiliationCountryFragment
} from '../../../../../../../../../gql/typings';
import Flag, { CountryLabel, FlagCountry } from '../../../../../../../../components/Flag/Flag';
import CountryPicker from '../../../../../../../../components/Input/Fields/CountryPicker';

const AdminMergeItemAffiliationCountry: React.FC<AdminEntityMergeRequestItemProps> = (props) => {
  const localization = useLocalization();
  const info = props.item.type as MergeItemAffiliationCountryFragment;

  const displayCountry = (country: FlagCountry) => (
    <span>
      <Flag country={country} rectangle height={24} />
      &nbsp;
      {localization.formatMessage(CountryLabel[country]!)}
    </span>
  );

  return (
    <AdminMergeItemBasicConflictField
      {...props}
      fromValue={info.fromAffiliationCountry || 'DK'}
      toValue={info.toAffiliationCountry || 'DK'}
      valueDisplayMapper={v => displayCountry(v as FlagCountry)}
      updateMutation={() => Promise.reject()}
      inputRenderer={({ value, onChange }) => <CountryPicker value={value as FlagCountry} onChange={onChange} />}
    >
      {localization.formatMessage(Locale.Text.Merge_request_countries_mismatch_description, {
        country1: (
          <span>
            <Flag country={info.fromAffiliationCountry as FlagCountry} rectangle height={24} />
            &nbsp;
            {localization.formatMessage(CountryLabel[info.fromAffiliationCountry as FlagCountry]!)}
          </span>
        ),
        country2: (
          <span>
            <Flag country={info.toAffiliationCountry as FlagCountry} rectangle height={24} />
            &nbsp;
            {localization.formatMessage(CountryLabel[info.toAffiliationCountry as FlagCountry])}
          </span>
        ),
      })}
    </AdminMergeItemBasicConflictField>
  );
};

gql`
  fragment MergeItemAffiliationCountry on AffiliationCountryCode_EntityDataToBeTransferredType {
    code
    entityType
    fromAffiliationCountry: fromCode
    toAffiliationCountry: toCode
  }
`;

export default AdminMergeItemAffiliationCountry;
